import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { staggeredFadeIn } from '../../utils/animations';

export function ClientTypeCard({ type, title, paragraphs, href, ctaLabel, testId, ctaTestId, delay }) {
    return (
        <motion.div
            {...staggeredFadeIn(delay)}
            className="bg-white/5 border border-white/10 rounded-sm p-10"
            data-testid={testId}
        >
            <p className="text-gold-400 text-xs font-bold tracking-[0.25em] uppercase font-inter mb-3">{type}</p>
            <h3 className="font-montserrat font-bold text-2xl text-white mb-4">{title}</h3>
            <div className="text-gray-300 text-sm leading-relaxed">
                {paragraphs.map((p, idx) => (
                    <p key={idx} className="mb-4 last:mb-0">{p}</p>
                ))}
            </div>
            <Link
                to={href}
                className="inline-flex items-center mt-6 text-gold-400 font-semibold text-sm hover:text-gold-300 transition-colors"
                data-testid={ctaTestId}
            >
                {ctaLabel} <span className="ml-1">&rarr;</span>
            </Link>
        </motion.div>
    );
}
